import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import DemoWizardItem from '../../../Domain/DemoWizardItem';

// Single-page variant for the gallery's edit-wizard demo (modeled on
// SetTimesheetUserWindowDescription). One page with few visible fields makes
// GeneralEditWizzardPageFigma render the compact centered modal instead of the
// full multi-step wizard — same component, no separate "panel" variant.
export default class DemoSinglePageWindowDescription {
  static titleForCreate = 'Select the Demo Category';
  static titleForEdit = 'Select the Demo Category';
  // No entityName: with entityName set the header shows the item's name (or
  // "New <entityName>") INSTEAD of titleForCreate/titleForEdit. Task-style
  // panels like SetTimesheetUserWindowDescription omit it so the title wins.
  static itemType = DemoWizardItem;
  static messageOnSuccess = 'Demo item "saved" (in-memory only — nothing was sent to the backend).';
  static finishButtonLabel = 'Finish';

  static serviceFunction = () => Promise.resolve({});

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'Name',
          label: 'Name *',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'CategoryId',
          label: 'Category',
          className: 'col-12',
          type: InputTypesEnum.Select,
          validityChecker: ValidityHelper.emptyValidityChecker,
          selectvalues: [
            { label: '-- Select --', value: '' },
            { label: 'Retail', value: 1 },
            { label: 'Hospitality', value: 2 },
            { label: 'Automotive', value: 3 },
          ],
        },
      ],
    },
  ];
}
